export default {
  data: () => ({
    style: { maxWidth: 'unset', maxHeight: 'unset', marginLeft: 'unset', marginRight: 'unset', footerFixed: true }    // Default

  }),

  mounted() {
    this.$emit("setStyle", this.style);
  }
}
